import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Game from "./components/Game/Game";
import RisingParticles from "./components/RisingParticles";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <RisingParticles />
        <Routes>
          <Route path="/CodeJam2024" element={<Home />} />
          <Route path="/presets" element={<Projects />} />
          <Route path="*" element={<Navigate to="/CodeJam2024" />} />
          <Route exact path="/game" element={<Game />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
